// public.ts — zod schema for the public widget API (spec D11/M4 task-1). Unlike every
// other schema in this package, the body here is filled in by an anonymous website
// visitor through the embeddable widget, not an authenticated dashboard user — kept
// deliberately tiny (no `intent`; that is the AI engine's lead-capture tool's concern
// server-side, not the raw POST body). `phone` IS accepted since 2026-08-22
// (lead-phone-capture design): the widget's forms offer it as an optional field, and the
// cap is a length rail only — phone format is never validated anywhere in this codebase.
import { z } from 'zod';

export const publicLeadSchema = z.object({
  email: z.string().email(),
  name: z.string().max(80).optional(),
  phone: z.string().trim().min(1).max(40).optional(),
  sessionKey: z.string().max(100).optional(),
});
